<div>
    <app-icon ic="IcEditPen" size="s" color="var(--color-primary-60)" (click)="editBtnAction()"></app-icon>
    <app-icon ic="IcTrash" size="s" color="var(--color-primary-60)" (click)="deleteBtnAction()"></app-icon>
</div>
